<div #container *ngIf="filters" class="d-flex align-items-stretch" style="flex: 1" [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport}">
    <ng-container *ngIf="!showInReport">
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <app-connection-image [connectionType]="mainConnectionType"></app-connection-image>
                Electricity consumption
                <app-tooltip class="ms-2" placement="top" *ngIf="completenessInfo">
                    <span class="notranslate" [style.color]="completenessInfo.color">{{completenessInfo.completeness}}%</span>
                    <div class="tooltipContent">
                        <span class="notranslate">{{completenessInfo.title}}</span>
                    </div>
                </app-tooltip>
            </h4>
            <app-data-provider-date-range class="ms-2" *ngIf="modalOptions.fullScreen"></app-data-provider-date-range>
            <button *ngIf="!modalOptions.fullScreen" type="button" class="btn" role="button" (click)="openModal()"><i class="bi bi-arrows-angle-expand"></i></button>
            <app-chart-download-button [element]="container" [tableElement]="tableElement"
                                       [connectionTypes]="connectionTypes"></app-chart-download-button>
            <button type="button" class="btn" role="button" (click)="toggleShowAsTable()"><i class="bi" [ngClass]="options.showAsTable ? 'bi-bar-chart-line' : 'bi-table'"></i></button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <div class="dropdown-menu" style="z-index: 1050;">
                <div class="dropdown-item" *ngIf="groupByEntityId && options.groupByEntityIdPossible && !onlyMetersSelected">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('groupByEntityId')"
                               [ngModel]="options.groupByEntityId" (ngModelChange)="groupByEntityIdChange($event)">
                        <label class="form-check-label" [for]="getInputId('groupByEntityId')">
                            Split by sub meters
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showConsumption')"
                               [ngModel]="options.showConsumption" (ngModelChange)="showConsumptionChange($event)">
                        <label class="form-check-label" [for]="getInputId('showConsumption')">
                            Show consumption
                        </label>
                    </div>
                </div>
                <div class="dropdown-item" *ngIf="isPortfolio">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showFeedIn')"
                               [ngModel]="options.showFeedIn" (ngModelChange)="showFeedInChange($event)">
                        <label class="form-check-label" [for]="getInputId('showFeedIn')">
                            Show feed-in
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <ng-container *ngIf="hasProductionMeter else noProductionAvailable">
                            <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showGrossProduction')"
                                   [ngModel]="options.showGrossProduction" (ngModelChange)="showGrossProductionChange($event)">
                        </ng-container>
                        <ng-template #noProductionAvailable>
                            <input class="form-check-input" type="checkbox" [id]="getInputId('showGrossProduction')" disabled>
                        </ng-template>
                        <label class="form-check-label" [for]="getInputId('showGrossProduction')">
                            <span class="me-2">Show production</span>
                            <i *ngIf="!hasProductionMeter" class="bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip" data-bs-placement="top"
                               title="No gross production meter available"></i>
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showCompleteness')"
                               [ngModel]="options.showCompleteness" (ngModelChange)="showCompletenessChange($event)">
                        <label class="form-check-label" [for]="getInputId('showCompleteness')">
                            Completeness
                        </label>
                    </div>
                </div>
                <div class="dropdown-item" *ngIf="!options.groupByEntityId">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('checkboxSplitOffPeakElectricity')"
                               [ngModel]="options.splitOffPeak" (ngModelChange)="splitOffPeakChange($event)">
                        <label class="form-check-label" [for]="getInputId('checkboxSplitOffPeakElectricity')">
                            Split off-peak
                        </label>
                    </div>
                </div>
                <div *ngIf="showConsumption() && productionDataTypes().length > 0" class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('nettedConsumption')"
                               [ngModel]="options.nettedConsumption" (ngModelChange)="nettedConsumptionChange($event)">
                        <label class="form-check-label" [for]="getInputId('nettedConsumption')">
                            Netted consumption
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showReactive')"
                               [ngModel]="options.showReactive" (ngModelChange)="showReactiveChange($event)">
                        <label class="form-check-label" [for]="getInputId('showReactive')">
                            Show reactive
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('checkboxCompareElectricity')"
                               [ngModel]="options.compare.enabled" (ngModelChange)="compareChange($event)">
                        <div class="row">
                            <label class="form-check-label col-auto" [for]="getInputId('checkboxCompareElectricity')">Compare with</label>
                            <app-select class="col px-0 notranslate" [ngModel]="options.compare" (ngModelChange)="comparedYearChange($event)"
                                        [options]="compareYearOptions" [small]="true" [formatter]="compareFormatter" [equalsFunction]="compareEquals"></app-select>
                        </div>
                    </div>
                </div>
                <div class="dropdown-item">
                    <ng-container *ngIf="isPortfolio else locationDashboardPower">
                        <ng-container *ngTemplateOutlet="portfolioDashboardPower"></ng-container>
                    </ng-container>
                </div>
                <div class="dropdown-item" *ngIf="AppContext.isAdminOrIntermediary()">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowIncidents')"
                               [ngModel]="options.showIncidents" (ngModelChange)="showIncidentsChange($event)">
                        <div class="row">
                            <label class="form-check-label col-auto" [for]="getInputId('checkboxShowIncidents')">Alerts</label>
                            <app-simple-multi-select *ngIf="options.showIncidents" class="col px-0" [ngModel]="options.selectedIncidents"
                                                     (ngModelChange)="incidentsChange($event)" [options]="incidentOptions" [equalsFunction]="compareIncidents">
                            </app-simple-multi-select>
                        </div>
                    </div>
                </div>
                <hr />
                <div><h4 class="dropdown-header">Weather</h4></div>
                <div *ngFor="let weatherType of appContext.weatherTypes" class="dropdown-item">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getWeatherInputId(weatherType)"
                               [checked]="isDataTypeSelected(weatherType)" (click)="toggleWeather(weatherType)">
                        <label class="form-check-label" [for]="getWeatherInputId(weatherType)">
                            {{appContext.measurementName(weatherType, false)}}
                        </label>
                    </div>
                </div>
            </div>
            <button *ngIf="modalOptions.fullScreen" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
    </ng-container>
    <div class="chart-body pt-0 mh-100" [ngClass]="{'p-0': options.showAsTable, 'card-body': !showInReport}">
        <ng-container *ngIf="showInReport else notInReport">
            <ng-container [ngTemplateOutlet]="chart"></ng-container>
            <app-chart-table class="w-100" [dataProvider]="chartDataProvider"
                             [compare]="options.compare"></app-chart-table>
        </ng-container>
        <ng-template #notInReport>
            <app-chart-table class="w-100" [ngClass]="{'d-none': !options.showAsTable}"
                             [dataProvider]="chartDataProvider" [compare]="options.compare"
                             (tableElement)="tableElement = $event" [splitOffPeak]="options.splitOffPeak"></app-chart-table>
            <ng-container *ngIf="!options.showAsTable">
                <ng-container *ngIf="_rawData; else loadingSkeleton">
                    <ng-container [ngTemplateOutlet]="chart"></ng-container>
                </ng-container>
            </ng-container>
            <ng-template #loadingSkeleton>
                <div class="pt-5">
                    <ngx-skeleton-loader count="1" [appearance]="'line'"
                                         [theme]="{ height: '250px', 'border-radius': '0.25rem' }">
                    </ngx-skeleton-loader>
                </div>
            </ng-template>
        </ng-template>
    </div>
</div>

<ng-template #chart>
    <app-bar-chart class="chart h-100 w-100" [stacked]="true" [y1AxisMeasurement]="measurementUnit()"
                   style="flex: 1" [y2AxisMeasurement]="y2AxisTitle" [powerAxisMeasurement]="powerAxisTitle"
                   [dataProvider]="chartDataProvider" [showNormalAxis]="options.splitOffPeak" [showCompleteness]="options.showCompleteness"
                   [selectedWeatherTypes]="options.selectedWeatherTypes" [weatherTypes]="appContext.weatherTypes"
                   [fullScreen]="modalOptions.fullScreen" [skipPaddingX]="modalOptions.fullScreen || showInReport"
                   [animationDuration]="showInReport ? 0 : 1000" [directiveView]="this" [splitOffPeak]="options.splitOffPeak"
                   [otherPlugins]="plugins">
    </app-bar-chart>
</ng-template>

<ng-template #portfolioDashboardPower>
    <div class="form-check">
        <ng-container *ngIf="selectedConnections.length !== 1 else enabled">
            <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')" disabled>
        </ng-container>
        <ng-template #enabled>
            <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')"
                   [ngModel]="options.showPower" (ngModelChange)="showPowerChange($event)">
        </ng-template>
        <label class="form-check-label" [for]="getInputId('checkboxShowPower')">
            <span class="me-2">Maximum power</span>
            <ng-container *ngIf="selectedConnections.length !== 1 else oneConnectionSelected">
                <i class="bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip" data-bs-placement="top"
                   title="Maximum power can only be shown per EAN"></i>
            </ng-container>
            <ng-template #oneConnectionSelected>
                <i *ngIf="!hasPower() else contractedCapacityEl" class="bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip"
                   data-bs-placement="top" title="Power data is unavailable for this connection"></i>
                <ng-template #contractedCapacityEl>
                    <i *ngIf="!contractedCapacity(mainConnectionType)" class="bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip"
                       data-bs-placement="top" title="Contracted power is unknown for this connection"></i>
                </ng-template>
            </ng-template>
        </label>
    </div>
</ng-template>
<ng-template #locationDashboardPower>
    <ng-container *ngIf="{ val: getSelectedEans()} as eanCodes">
        <div class="form-check">
            <ng-container *ngIf="eanCodes.val.length === 0 else enabled">
                <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')" disabled>
            </ng-container>
            <ng-template #enabled>
                <ng-container *ngIf="hasPower() else noPowerFound">
                    <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')"
                           [ngModel]="options.showPower && showPowerForEan(mainConnectionType)"
                           (ngModelChange)="showPowerChange($event)">
                </ng-container>
                <ng-template #noPowerFound>
                    <input class="form-check-input" type="checkbox" [id]="getInputId('checkboxShowPower')" disabled>
                </ng-template>
            </ng-template>
            <div class="row">
                <label class="form-check-label col-auto" [for]="getInputId('checkboxShowPower')">Maximum power</label>
                <ng-container *ngIf="eanCodes.val.length > 1 else noConnections">
                    <ng-container *ngIf="hasPower() else noPowerFoundInner">
                        <app-select class="col px-0 notranslate" [ngModel]="options.showPowerForEan" (ngModelChange)="showPowerForEanChange($event)"
                                    [options]="eanCodes.val" [small]="true"></app-select>
                    </ng-container>
                    <ng-template #noPowerFoundInner>
                        <i class="col-auto ps-0 bi bi-exclamation-triangle-fill" data-bs-toggle="tooltip"
                           data-bs-placement="top" title="Power data is unavailable for this connection"></i>
                    </ng-template>
                </ng-container>
                <ng-template #noConnections>
                    <i *ngIf="eanCodes.val.length === 0" class="col-auto bi bi-exclamation-triangle-fill"
                       data-bs-toggle="tooltip" data-bs-placement="top" title="No connections found within selection"></i>
                </ng-template>
            </div>
        </div>
    </ng-container>
</ng-template>